/** Curated lucide icons available for Training Focus Area tiles.
 * Stored in the DB by name; rendered via this map. */
import {
  Compass, MessageCircle, HeartHandshake, ShieldCheck, Users, Award, School,
  Home, GraduationCap, Target, ClipboardList, Sparkles, Lightbulb, TrendingUp,
  Star, BookOpen, Briefcase, Heart, Globe, Mic, Handshake, Brain,
} from "lucide-react";

export const FOCUS_ICONS = {
  Compass, MessageCircle, HeartHandshake, ShieldCheck, Users, Award, School,
  Home, GraduationCap, Target, ClipboardList, Sparkles, Lightbulb, TrendingUp,
  Star, BookOpen, Briefcase, Heart, Globe, Mic, Handshake, Brain,
};

export const focusIcon = (name) => FOCUS_ICONS[name] || Sparkles;
